<script>
  import PartialCircleElementTorte from "./PartialCircleElementTorte.svelte";
  import BalkenLeadsOppsCustBoli from "./BalkenLeadsOppsCustBoli.svelte";
  import Chart1MarketBubblesLegend from "./Chart1MarketBubblesLegend.svelte";
  import Chart2BarDiagramLeadsLegend from "./Chart2BarDiagramLeadsLegend.svelte";
  import FourDataTable from "./FourDataTable.svelte";

  export let laender_dict;
  export let adressable_market_size_charts_dict;
  export let balken_leads_opps_cust_boli;
  export let laender_dict_targets;
  export let active_boli_end_of_timeframe;
  export let acq_cost_dict;
  export let cost_per_new_customer;
  export let cost_per_new_cow;
  export let active_boluses_per_customer;
  export let active_customers_per_month;
  export let average_herd_size;
  export let open_leads_per_country;
  export let new_leads_target;
  export let open_opps_per_country;
  export let customer_churn;
  export let table_sold_boli_dict_per_country;
  export let boli_odoo_table;
  export let lost_boli_per_country;
  export let herd_churn_per_country;
  export let active_animals_table_values;
  export let sold_boli_target;

  export let helptexts;
  export let in_show_helptext_id;

  export let marketing_end_date;
  export let marketing_start_date;
  export let is_ytd;

  let color_list = ["#51c3f9", "#44C1A3", "#37A76F", "#63A537", "#"];
</script>

<table style="margin-left:10px; margin-right:20px;">
  <tr style="text-align: center;">
    <th />

    {#each laender_dict as land_eintrag, index}
      {#if land_eintrag["checked"]}
        <th>
          <div
            style="color:#FFFFFF; background-color: #87A896; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px; margin:15px;"
          >
            <span>{land_eintrag["short"]}</span>
          </div>
        </th>
      {/if}
    {/each}

    <th style="text-align: bottom">
      <div
        style="
                background-color: #455f51;color: #FFFFFF; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px; margin:15px;"
      >
        <span>Total</span>
      </div>
    </th>
  </tr>

  <tr>
    <td style="height: 200px;"><Chart1MarketBubblesLegend /></td>

    {#each laender_dict as land_eintrag, index}
      {#if land_eintrag["checked"]}
        <td style="height: 200px;">
          <PartialCircleElementTorte
            winkel_innen={adressable_market_size_charts_dict[land_eintrag["short"]]["AMS_percentage"]}
            winkel_outer={adressable_market_size_charts_dict[land_eintrag["short"]]["AMT_percentage"]}
            number={1100 + index}
            radius={land_eintrag["radius"]}
          />
        </td>
      {/if}
    {/each}

    <td style="height: 200px;">
      <PartialCircleElementTorte
        is_total={true}
        winkel_innen={adressable_market_size_charts_dict["Total"]["AMS_percentage"]}
        winkel_outer={adressable_market_size_charts_dict["Total"]["AMT_percentage"]}
        number={1099}
        radius={60}
      />
    </td>
  </tr>

  <tr>
    <td style="height: 200px; vertical-align:bottom;"><Chart2BarDiagramLeadsLegend {color_list} /></td>

    {#each laender_dict as land_eintrag, index}
      {#if land_eintrag["checked"]}
        <td style="height: 200px; ">
          <BalkenLeadsOppsCustBoli
            country_long={land_eintrag["long"]}
            max_values={balken_leads_opps_cust_boli["Total"]}
            values={balken_leads_opps_cust_boli[land_eintrag["long"]]}
            {color_list}
            text_unten={land_eintrag["short"]}
          />
        </td>
      {/if}
    {/each}

    <td style="height: 200px;">
      <BalkenLeadsOppsCustBoli
        country_long={"Total"}
        max_values={balken_leads_opps_cust_boli["Total"]}
        values={balken_leads_opps_cust_boli["Total"]}
        {color_list}
        text_unten={"TOTAL"}
      />
    </td>
  </tr>

  <FourDataTable
    {laender_dict}
    {laender_dict_targets}
    {active_boli_end_of_timeframe}
    {adressable_market_size_charts_dict}
    {acq_cost_dict}
    {cost_per_new_customer}
    {cost_per_new_cow}
    {active_boluses_per_customer}
    {active_customers_per_month}
    {average_herd_size}
    {new_leads_target}
    {balken_leads_opps_cust_boli}
    {open_leads_per_country}
    {open_opps_per_country}
    {customer_churn}
    {table_sold_boli_dict_per_country}
    {boli_odoo_table}
    {lost_boli_per_country}
    {herd_churn_per_country}
    {active_animals_table_values}
    {sold_boli_target}
    {marketing_end_date}
    {marketing_start_date}
    {is_ytd}
    {helptexts}
    {in_show_helptext_id}
  />
</table>
